import type React from 'react';

import { translate } from '../../services/i18n';

import { PaginationControl } from './PaginationControl';
import { StyledControlsWrapper, StyledCurrentPage, StyledTotalPages } from './styles';

interface PaginationProps {
  currentPage: number;
  itemsCount: number;
  handlePageChange: (page: number) => void;
  itemsPerPage: number;
}

export const Pagination: React.FC<PaginationProps> = ({ currentPage, itemsCount, handlePageChange, itemsPerPage }) => {
  const pagesCount = Math.ceil(itemsCount / itemsPerPage);

  return (
    <StyledControlsWrapper>
      <PaginationControl direction="left-end" onClick={() => handlePageChange(1)} disabled={currentPage === 1} />
      <PaginationControl
        direction="left"
        onClick={() => handlePageChange(currentPage - 1)}
        disabled={currentPage === 1}
      />
      <StyledCurrentPage>{currentPage}</StyledCurrentPage>
      <span>{translate('common.pagination')}</span>
      <StyledTotalPages>{pagesCount}</StyledTotalPages>
      <PaginationControl
        direction="right"
        onClick={() => handlePageChange(currentPage + 1)}
        disabled={currentPage === pagesCount}
      />
      <PaginationControl
        direction="right-end"
        onClick={() => handlePageChange(pagesCount)}
        disabled={currentPage === pagesCount}
      />
    </StyledControlsWrapper>
  );
};
